export const DASHBOARDS_CONFIG = 'dashboards_config'
export const TDR_BANK_CONFIG = 'tdr_bank_config'
export const TG_LOCATION_DETAILS_KML_CONFIG =
   'tg_location_details_mapbox_config'
export const GEO_SCRUTINY_ENGINE_CONFIG = 'geo_scrutiny_engine_config'
export const LEGACY_APPLICATIONS_CONFIG = 'bpass_applications_config'
export const BPASS_APPLICATIONS_CITIZEN_SEARCH_CONFIG =
   'bpass_applications_citizen_search_config'

export enum TGLocationDetailsKmlConfigKeyEnum {
   TILESET_ID = 'tileset_id',
   ACCESS_TOKEN = 'access_token'
}

export enum GeoScrutinyEngineConfigKeyEnum {
   TILESET_ID = 'tileset_id',
   ACCESS_TOKEN = 'access_token',
   ENABLE_GEO_SCRUTINY_ENGINE = 'enable_geo_scrutiny_engine'
}

export enum DynamicFeatureTogglesTier {
   STAGING = 'staging',
   PRODUCTION = 'production',
   DEVELOPMENT = 'development'
}

// #region dashboards config
export enum DashboardsConfigMode {
   MAINTENANCE = 'MAINTENANCE',
   ACTIVE = 'ACTIVE'
}

export enum DashboardsConfigKeyEnum {
   MODE = 'mode',
   ENABLE_AT = 'enable_at'
}

// #endregion

// #region dashboards config
export enum TDRBankConfigKeyEnum {
   IS_ENABLED = 'is_enabled'
}

// #endregion

// #region legacy applications config
export enum LegacyApplicationsConfigKeyEnum {
   IS_ENABLED = 'is_enabled',
   USER_IDS = 'user_ids'
}

// #endregion

// #region bpass applications citizen search config
export enum BPassApplicationsCitizenSearchConfigKeyEnum {
   IS_ENABLED = 'is_enabled'
}

// #endregion
